export enum Languages {
  ANY = 'any',
  EN = 'en',
  RU = 'ru',
  UK = 'ua',
}